module.exports = __webpack_public_path__ + "static/frontend-616a3068718bb92e866d53b6adcd9021.jpg";